module.exports = __webpack_public_path__ + "media/src/assets/images/mv-a685c78b8657af5c2c98387931a5bf28.jpg";